<template>
  <div slot="body">
    <!-- 弹窗-查询表单 -->
    <div class="md-layout">
      <!-- 选择栏-导入状态 {0: 全部, 1: 已导入, 2: 有错误, 3: 文件错误, 4: 待导入, 5: 正在导入}-->
      <div class="md-layout-item md-size-25 left-layout-item">
        <md-field>
          <label>{{$I18n("import_state")}}</label>
          <md-select v-model="modalExportSearchData.state">
            <md-option :value="0">{{$I18n("all")}}</md-option>
            <md-option :value="1">{{$I18n("import_succ_a")}}</md-option>
            <md-option :value="2">{{$I18n("import_fail_s")}}</md-option>
            <md-option :value="3">{{$I18n("import_fail_a")}}</md-option>
            <md-option :value="4">{{$I18n("wait_import")}}</md-option>
          </md-select>
        </md-field>
      </div>
      <!-- 时间选择-导入时间 -->
      <!-- <div class="md-layout-item md-size-40 left-layout-item">
        <md-field class="md-theme-default md-has-value">
          <label>{{$I18n("export_time")}}</label>
          <el-date-picker :picker-options="pickerOptions" :start-placeholder="$I18n('start')" :end-placeholder=" $I18n('end')" v-model="modalExportSearchData.time" class="md-date-form-item" align="left" type="daterange" range-separator="~" value-format="yyyy-MM-dd HH:mm:ss" />
        </md-field>
      </div> -->
      <!-- 按钮-提交查询 -->
      <div class="md-layout-item left-btn">
        <md-button class= "left-icon md-info" @click="modal_changeSearchExportData">
          <md-icon>search</md-icon>
          {{$I18n("search")}}
        </md-button>
      </div>
    </div>
    <!-- 弹窗-表格
      ID
      用户ID
      企业名称
      体系
      文件下载链接
      文件处理数据数量详情
      状态 {1: 已导入, 2: 有错误, 3: 文件错误, 4: 待导入, 5:正在导入}
      导入时间
      完成时间
     -->
    <md-table v-if="modalExportTableData.length > 0" v-model="modalExportTableData" class="left-table">
      <md-table-row>
        <md-table-head :style="{'text-align':'center'}">{{$I18n('import_id')}}</md-table-head>
        <md-table-head :style="{'text-align':'center'}">{{$I18n('import_file')}}</md-table-head>
        <md-table-head :style="{'text-align':'center'}">{{$I18n('import_state')}}</md-table-head>
        <!-- <md-table-head :style="{'text-align':'center'}">{{$I18n('time_period')}}</md-table-head> -->
        <md-table-head :style="{'text-align':'center'}">{{$I18n('create_time')+ '/' +$I18n('update_date')}}</md-table-head>
      </md-table-row>
      <md-table-row v-for="(item, index) in modalExportTableData" :key="index">
        <md-table-cell>{{ item.id }}</md-table-cell>
        <md-table-cell>
          <!-- 有下载地址 -->
          <a v-if="item.link_id" :style='{color:"blue"}' :download="`import-${item.id}.xlsx`" :href="item.link_id">
            {{`import-${item.id}.xlsx`}}
          </a>
          <!-- 没有下载链接 -->
          <span v-else>{{$I18n("is_none")}}</span>
        </md-table-cell>
        <md-table-cell>
          <span v-if="item.state == 1" :style="{color:'green'}">
            {{$I18n("import_succ_a")}}
          </span>
          <span v-else-if="item.state == 2" :style="{color:'red'}">
            {{$I18n("import_fail_s")}}
          </span>
          <span v-else-if="item.state == 3" :style="{color:'red'}">
            {{$I18n("import_fail_a")}}
          </span>
          <span v-else-if="item.state == 4" :style="{color:'red'}">
            {{$I18n("wait_import")}}
          </span>
        </md-table-cell>
        <!-- <md-table-cell>{{ item.start_time }}-{{item.end_time}}</md-table-cell> -->
        <md-table-cell>{{ item.create_time }}/{{ item.update_time }}</md-table-cell>
      </md-table-row>
    </md-table>
    <md-table v-else v-model="modalExportTableData" class="left-table">
      <md-table-row slot="md-table-row" slot-scope="{item}">
        <md-table-cell :md-label="$I18n('update_time')">{{ item.update_time }}</md-table-cell>
        <md-table-cell :md-label="$I18n('update_time')">{{ item.update_time }}</md-table-cell>
        <md-table-cell :md-label="$I18n('update_time')">{{ item.update_time }}</md-table-cell>
        <md-table-cell :md-label="$I18n('update_time')">{{ item.update_time }}</md-table-cell>
      </md-table-row>
      <md-table-empty-state slot="md-table-empty-state"> {{$I18n("none_data")}} </md-table-empty-state>
    </md-table>
    <table-page :total="import_export_total" :pageSize="import_pageSize" v-model="import_exportCurrentPage"/>
  </div>
</template>

<script>
import { timestampToString1000 } from "@/common/tools.js";
// import { nDaysAgo, nMonthsAgo, timestampToString1000, formatJsonForNotes, getInitComp } from "@/common/tools.js";
export default {
  data() {
    return {
      modalExportTableInitData: [],
      modalExportSearchData:{
        state: 0,
        // time: [],
      },
      modalExportSearchForm:{
        state: 0,
        // time: [],
      },
      import_pageSize: 10,
      import_exportCurrentPage: 1,
      import_export_total: 0,
    }
  },
  watch:{
    import_exportCurrentPage(){
      this.api_getExportXlsxData();
    },
  },
  created(){
    this.api_getExportXlsxData();
  },
  computed:{
    modalExportTableData() {
      if (!this.modalExportTableInitData || this.modalExportTableInitData.length === 0){
        return [];
      } else {
        return [...this.modalExportTableInitData.map(item => {
          return {
            ...item,
            // comp_name,
            create_time : timestampToString1000(item.gmt_create),
            update_time : timestampToString1000(item.gmt_update),
            // start_time  : timestampToString1000(item.gmt_start).split(" ")[0],
            // end_time    : timestampToString1000(item.gmt_end).split(" ")[0],
          }
        })]
      }
    },
  },
  methods: {
    modal_changeSearchExportData(){
      this.import_exportCurrentPage = 1;
      this.modalExportSearchForm = {...this.modalExportSearchData}
      this.api_getExportXlsxData();
    },
    api_getExportXlsxData(){
      this.$api.getUserTagsXls({
        ...this.modalExportSearchForm,
        page_size: this.import_pageSize,
        page_no: this.import_exportCurrentPage,
      })
        .then(this.$Then(resData => {
          this.modalExportTableInitData = resData.data;
          this.import_export_total = resData.count;
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.modalExportTableInitData = [];
          this.import_export_total = 0;
        }))
    },
  },
}
</script>